import 'css-chunksrc/client/common/layoutWatcher/styles.scss';export default {
  "layoutWatcher": "_layoutWatcher_139c8_1"
};